var UISelectSearch = (function ($) {

    UISelectSearch = function () {
        var that = this;

        // INIT
        that.initEventHandlers();
    };

    UISelectSearch.prototype.scrollbar_theme = 'scrollbar';

    UISelectSearch.prototype.class = {
        focus: 'focus',
        not_empty: 'not-empty',
        error: 'error',
        selected: 'selected'
    };

    UISelectSearch.prototype.initEventHandlers = function () {
        var that = this;

        var timer = null;
       
        // EVENT: полноэкранный поиск
        $.sa.$document.on('input keydown', '.select-search-input', function (e) {
            const $search_input = $(this)
            const $search_input_wrapper = $search_input.parents('.select-search-input-wrapper')
            const $search_close_icon = $search_input_wrapper.find('.icon-clear.js-clear')

            timer && clearTimeout(timer);
            timer = setTimeout(function () {
                var search_value = $search_input.val();
                if (search_value.length) {
                    $search_input_wrapper.addClass(that.class.not_empty);
                    $search_close_icon.show();
                } else {
                    $search_input_wrapper.removeClass(that.class.not_empty);
                    $search_close_icon.hide();
                }
            }, 100);
        })

        $.sa.$document.on('focus', '.select-search-input', function () {
            const $search_input = $(this)
            const $search_input_wrapper = $search_input.parents('.select-search-input-wrapper')

            $search_input_wrapper.addClass(that.class.focus);
        })

        $.sa.$document.on('blur', '.select-search-input', function () {
            const $search_input = $(this)
            const $search_input_wrapper = $search_input.parents('.select-search-input-wrapper')

            $search_input_wrapper.removeClass(that.class.focus);
        });

        $.sa.$document.on('click', '.icon-clear.js-clear', function () {
            const $search_close_icon = $(this)
            const $search_input_wrapper = $search_close_icon.parents('.select-search-input-wrapper')
            const $search_input = $search_input_wrapper.find('.select-search-input')

            $search_close_icon.hide();
            $search_input_wrapper.removeClass(that.class.not_empty);
            $search_input.val('').focus();

            $search_input.trigger($.Event("keydown"));
        })
    };

    return UISelectSearch;
})($);
